import { MBrandElementProps } from '../../molecules/MBrandElement/MBrandElement.types';
import { MTextBlockFullProps } from '../../molecules/MTextBlockFull/MTextBlockFull.types';
import { MButtonProps } from '../../molecules/MButton/MButton.types';
import { MPhotoCaptionProps } from '../../molecules/MPhotoCaption/MPhotoCaption.types';
import type { DACImage } from '../../utils/ImageUtils';

export enum OHeroContentBlockDesktopContentAlignment {
  NA = 'N/A',
  RIGHT = 'Right',
  CENTER = 'Center',
  LEFT = 'Left',
}

export enum OHeroContentBlockImageScale {
  SMALL = 'Small',
  LARGE = 'Large',
  MEDIUM = 'Medium',
}

export interface OHeroContentBlockAImage {
  image?: DACImage;
}

export interface OHeroContentBlockTrackingProperties {
  location?: string;
  trackingTag?: string;
  trackingContentPosition?: string;
  trackingDescription?: string;
  trackingOfferType?: string;
  merchandisingCategory?: string;
  atCCeVar48?: string;
  faicUrl?: string;
  clickTrack?: boolean;
  impressionTrack?: boolean;
  impressionCount?: boolean;
  enableScrollingBehavior?: boolean;
  leftArrowDesc?: string;
  cardLocation?: string;
  rightArrowDesc?: string;
  description?: string;
  faicMCD?: string;
  additionalTrackingVariables?: string;
}

export interface OHeroContentBlockProps extends React.HTMLAttributes<HTMLDivElement> {
  buttonGroup?: boolean;
  photoCaption?: boolean;
  desktopContentAlignment?: OHeroContentBlockDesktopContentAlignment;
  imageScale?: OHeroContentBlockImageScale;
  aImage?: OHeroContentBlockAImage;
  mBrandElement?: MBrandElementProps;
  mTextBlockFull?: MTextBlockFullProps;
  mButton?: MButtonProps;
  mButton2?: MButtonProps;
  mPhotoCaption?: MPhotoCaptionProps;
  trackingProperties?: OHeroContentBlockTrackingProperties;
  className?: string;
}
